import { HeaderIds } from "src/helpers/uiConstants";
import { TypographyH2, TypographyP } from "./Typography";
import AlternativesExplanationDetails from "./ui/AlternativesExplanationDetails";
import LazyScroll from "./ui/LazyScroll";
import { isMobile } from "src/helpers/mapConstants";

export default function WhatWeStudied() {
  return (
    <div className="mt-6">
      <TypographyH2
        id={HeaderIds.whatWeStudiedHeader}
        className="mb-2"
        textId="whatWeStudiedTitle"
      />
      <TypographyP className="mb-4" textId="whatWeStudiedDescription" />
      <TypographyP className="mb-6" textId="alternativesButtonsInstructions" />
      <LazyScroll height={isMobile ? "714px" : "690px"}>
        <div className="w-full flex justify-center mb-6">
          <AlternativesExplanationDetails />
        </div>
      </LazyScroll>
      <TypographyP className="mb-6" textId="whatWeStudiedDescription2" />
    </div>
  );
}
